export enum UserRole {
  ADMINISTRATOR = 'administrator',
  SUPERVISOR = 'supervisor',
  CSR = 'csr',
  DEALER = 'dealer',
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: UserRole;
  manufacturer?: string;
  manufacturerId?: number;
  dealer?: string;
  dealerId?: number;
  avatar?: string;
  active: boolean;
  allowSignOffOnTasks?: boolean;
}
